import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from './config';
import { useAuth } from './Auth';
// ?? ??????? ?????????
import { FaCog, FaUsers, FaFilePdf, FaStar, FaTrash } from 'react-icons/fa';

const AdminSettings = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth(); 

  // ??? ??????????
  const fetchUsers = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/admin/users-stats`);
      setUsers(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  // ??? ??????
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user? This will remove all their data!")) {
      try {
        await axios.delete(`${API_URL}/users/${id}`);
        setUsers(users.filter(u => u._id !== id));
        alert("? User deleted successfully");
      } catch (error) {
        alert("? Failed to delete user");
      }
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div style={{ padding: '30px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      
      {/* Header */}
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d3436', fontSize: '28px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaCog color="#636e72" /> Admin Dashboard
        </h2>
        <p style={{ color: '#636e72', marginLeft: '40px' }}>Platform Overview & User Management</p>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px', flexWrap: 'wrap' }}>
        <div style={styles.card}>
          <h3 style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
             <FaUsers color="#55efc4" /> Total Users
          </h3>
          <p style={styles.number}>{users.length}</p>
        </div>
        <div style={styles.card}>
          <h3 style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
             <FaFilePdf color="#ff7675" /> Total PDFs Generated
          </h3>
          <p style={styles.number}>
            {users.reduce((acc, curr) => acc + (curr.pdf_count || 0), 0)}
          </p>
        </div>
        <div style={styles.card}>
          <h3 style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
             <FaStar color="#f1c40f" /> Premium Users
          </h3>
          <p style={styles.number}>
            {users.filter(u => u.role === 'pro' || u.role === 'admin').length}
          </p>
        </div>
      </div>

      {/* Users Table */}
      <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#f1f2f6' }}>
            <tr>
              <th style={styles.th}>User</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Plan</th>
              <th style={styles.th}>Activity (PDFs)</th>
              <th style={styles.th}>Joined</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="6" style={{ textAlign: 'center', padding: 20 }}>? Loading data...</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan="6" style={{ textAlign: 'center', padding: 20 }}>No users found.</td></tr>
            ) : (
              users.map((u) => (
                <tr key={u._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={styles.avatar}>{u.name.charAt(0).toUpperCase()}</div>
                      <strong>{u.name}</strong>
                    </div>
                  </td>
                  <td style={styles.td}>{u.email}</td>
                  <td style={styles.td}>
                    <span style={{ 
                      padding: '4px 10px', 
                      borderRadius: '15px', 
                      fontSize: '12px',
                      backgroundColor: u.role === 'admin' ? '#ffeaa7' : (u.role === 'pro' ? '#55efc4' : '#dfe6e9'),
                      color: '#2d3436',
                      fontWeight: 'bold'
                    }}>
                      {u.role.toUpperCase()}
                    </span>
                  </td>
                  <td style={styles.td} align="center">
                    <span style={{ fontWeight: 'bold', color: '#0984e3' }}>{u.pdf_count || 0}</span>
                  </td>
                  <td style={styles.td}>
                    {new Date(u.createdAt).toLocaleDateString()}
                  </td>
                  <td style={styles.td}>
                    {u.role !== 'admin' && (
                      <button 
                        onClick={() => handleDelete(u._id)}
                        style={styles.deleteBtn}
                        title="Delete User"
                      >
                        <FaTrash /> Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// CSS Styles
const styles = {
  card: { flex: '1 1 200px', background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', textAlign: 'center' },
  number: { fontSize: '24px', fontWeight: 'bold', color: '#0984e3', margin: '10px 0 0' },
  th: { padding: '15px', textAlign: 'left', color: '#636e72', fontSize: '13px', textTransform: 'uppercase', fontWeight: '600' },
  td: { padding: '15px', color: '#2d3436', fontSize: '14px' },
  avatar: { width: '32px', height: '32px', background: '#74b9ff', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' },
  deleteBtn: { display: 'flex', alignItems: 'center', gap: '5px', background: '#ff7675', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', transition: '0.2s' }
};

export default AdminSettings;